import script from "./TankDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TankDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./TankDetailsModal.vue?vue&type=style&index=0&id=5c32daae&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c32daae"]])

export default __exports__